<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong> Fee Details Report </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row dense justify="center" class="no-display">
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="current_academic_year" :items="academic_year_list"
                        item-text="ay" return-object label="Academic Year" outlined @change="clearselection"
                        persistent-hint hint="Please Select Academic Year"></v-autocomplete>
                </v-col>
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="stream" :items="stream_list" item-text="stream"
                        item-value="id" label="Stream" outlined @change="clearselection" persistent-hint
                        hint="Please Select Stream"></v-autocomplete>
                </v-col>
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="header" :items="header_list" item-text="category"
                        item-value="id" label="Fee Header" outlined @change="clearselection()" persistent-hint
                        hint="Please Select Fee Header"></v-autocomplete>
                </v-col>
                <v-col sm="2">
                    <v-btn rounded class="button mt-6" @click="
              getStreamData();
              getSubHeader();
            ">
                        Proceed
                    </v-btn>
                </v-col>
            </v-row>
            <v-row justify="center" dense v-if="show" class="no-display">
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete multiple rounded dense required v-model="sub_header" :items="sub_header_data"
                        item-text="name" item-value="id" label="Fee Sub Header" outlined @change="clear()"
                        persistent-hint hint="Please Select Fee Sub Header"></v-autocomplete>
                </v-col>
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="std" :items="standard_list" item-text="standard"
                        item-value="id" label="Standard" outlined @change="
              getStandard();
              clear();
            " persistent-hint hint="Please Select  Standard"></v-autocomplete>
                </v-col>
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required multiple v-model="div" :items="dision_list"
                        item-text="div_name" item-value="div_off_id" label="Division" outlined @change="clear()"
                        persistent-hint hint="Please Select Division"></v-autocomplete>
                </v-col>
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="status" :items="status_list"
                        item-text="name" item-value="id" label="Status" outlined persistent-hint hint="Select Status" />
                </v-col>
                <v-col sm="2">
                    <v-btn rounded class="button mt-6" @click="getAllReport()" :loading="loader">Fetch</v-btn>
                </v-col>
            </v-row>
            <v-col cols="12" sm="12" md="12" v-if="learner_info != ''" class="">
                <strong><center>Note - Student status is as of today, not status during the academic year</center></strong>
                <!-- {{learner_info}} -->
                <!--  <div class="scroll">
                    <table id="admitted-student-report" dense class="elevation-1 mytable ">
                        <thead>
                            <tr>
                                <th>Sr.No.</th>
                                <th>Registration No.</th>
                                <th>Name</th>
                                <th>Mobile No.</th>
                                <th>Academic Year</th>
                                <th>Standard</th>
                                <th>Division</th>
                                <th>Fee Header</th>
                                <th>Amuont</th>
                                <th>Paid</th>
                                <th>Remaining</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="s in learner_info" :key="s.id">
                                <td>{{s.sr_no}}</td>
                                <td>{{s.reg_no}}</td>
                                <td>{{s.name}}</td>
                                <td>{{s.mobile_no}}</td>
                                <td>{{s.academicyear}}</td>
                                <td>{{s.standard}}</td>
                                <td>{{s.div}}</td>
                                <td>{{s.feescomponentacademicyear}}</td>
                                <td>{{s.amount}}</td>
                                <td>{{s.paid_till_now}}</td>
                                <td>{{s.remaining}}</td>
                            </tr>
                        </tbody>
                    </table>
                    </div> -->
                <!-- <v-col sm="2">
                    <v-btn rounded  color="success" outlined @click="ExportToExcel();" :loading="loader"><v-icon   color="success">mdi-export</v-icon>Export</v-btn>
                </v-col> -->
                <v-row dense>
                    <v-col cols="12" sm="2" md="2">
                        <v-btn class="ma-2 no-display" rounded color="success" outlined
                            @click="fnExcelReport('my-table-id', 'feedetailedreport')" :loading="loader"><v-icon
                                color="success">mdi-export</v-icon>Export</v-btn>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-btn class="ma-2 no-display" tile outlined color="warning" @click="showLogo()">
                            Hide /Show Logo
                        </v-btn>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-btn class="ma-2 no-display" tile outlined color="warning" @click="printReport()"> <v-icon
                                left>mdi-printer</v-icon> Print <v-icon right></v-icon> </v-btn>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                        <v-text-field class="ma-2 no-display" v-model="search" append-icon="mdi-magnify"
                            label="Search by Student name or by Registration Number" single-line
                            hide-details></v-text-field>
                    </v-col>
                </v-row>
                <div id="my-table-id">
                    <!-- header code -->
                    <v-simple-table></v-simple-table>
                    <div v-if="org_basic_data">
                        <v-row dense justify="center">
                            <v-col cols="12" sm="4" md="2" v-if="org_basic_data.trust_logo && show_logo" align="center">
                                <img :src="org_basic_data.trust_logo" alt="logo" class="trust-logo" />
                            </v-col>
                            <v-col cols="12" sm="4" md="8">
                                <center>
                                    <h2>
                                        <strong>{{ org_basic_data.trust_name }}</strong>
                                    </h2>
                                    <h3>
                                        <strong>{{ org_basic_data.school_name }} </strong>
                                    </h3>
                                    <span>{{ org_basic_data.address }}</span> <br />
                                    <span>Phone :{{ org_basic_data.phone }} </span> <br />
                                    <span>Email :{{ org_basic_data.email }} </span> <br />
                                    <span>Website :{{ org_basic_data.website }} </span>
                                    <br />
                                </center>
                            </v-col>
                            <v-col cols="12" sm="4" md="2" v-if="org_basic_data.school_logo && show_logo">
                                <img :src="org_basic_data.school_logo" alt="logo" class="schl-logo" />
                            </v-col>
                        </v-row>
                    </div>
                    <div>
                        <center>
                            <b>
                                <span>Fee Details Report </span>
                            </b>
                        </center>
                    </div>
                    <!-- header end -->
                    <div class="scroll">
                        <v-simple-table dense class="elevation-1 table-scroll" fixed-header>
                            <thead>
                                <tr>
                                    <th class="">Sr. No.</th>
                                    <th class="">Registration No.</th>
                                    <th class="">Name</th>
                                    <th class="">Learner Status</th>
                                    <th class="">Mobile No.</th>
                                    <th class="">Quota</th>
                                    <th class="">Academic Year</th>
                                    <th class="">Standard</th>
                                    <th class="">Division</th>
                                    <th class="">Admission Year</th>
                                    <th class="" colspan="3" v-for="(header, index) in component_headers" :key="index">
                                        <center>{{ header }}</center>
                                    </th>
                                </tr>
                            </thead>
                            <tbody style="overflow-y: scroll;">
                                <tr>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th v-for="(header, index) in component_headers.length * 3" :key="index">
                                        <span v-if="header % 3 == 0"> Total </span>
                                        <span v-else-if="header % 3 == 1"> Paid </span>
                                        <span v-else> Balance </span>
                                    </th>
                                </tr>
                                <!-- <tr v-for="s in learner_info" :key="s.id"> -->
                                <tr v-for="s in filteredItems" :key="s.id">
                                    <td>{{ s.sr_no }}</td>
                                    <td>{{ s.reg_no }}</td>
                                    <td>{{ s.name }}</td>
                                    <td>
                                        <span v-if="s.learner_status == 0" >
                                           Active
                                        </span>
                                        <span v-else-if="s.learner_status == 1">
                                            Temporary Inactive
                                        </span>
                                        <span v-else>
                                            Permanent Inactive
                                        </span>
                                        </td>
                                    <td>{{ s.mobile_no }}</td>
                                    <td>{{ s.quota }}</td>
                                    <td>{{ s.academicyear }}</td>
                                    <td>{{ s.standard }}</td>
                                    <td>{{ s.div }}</td>
                                    <td>{{ s.learner_addmission_year }}</td>
                                    <td v-for="(header, index) in s.comp_amt" :key="index">
                                        <span v-if="header == 'Not Applicable'" class="text-color">
                                            {{ header }}
                                        </span>
                                        <span v-else>
                                            {{ header }}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </div>
                    <v-row dense justify="center" class="pagebreak" v-if="data_list != ''">
                        <!--<table id="admitted-student" dense class="elevation-1 mytable"> -->
                        <chart auto-resize :options="option"></chart>
                    </v-row>
                    <v-row dense justify="center" v-if="data_list != ''">
                        <v-simple-table dense class="elevation-1" fixed-header>
                            <thead>
                                <tr>
                                    <th class="">Sr. No.</th>
                                    <th class="">Header</th>
                                    <th class="">Total amount to be collected</th>
                                    <th class="">Total amount collected</th>
                                    <th class="">Total amount pending</th>
                                    <th class="">Total Percentage amount collected</th>
                                    <th class="">Total Percentage amount pending</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(l, index) in data_list" :key="l.id">
                                    <td>{{ index + 1 }}</td>
                                    <td>{{ l.feescomponentacademicyear }}</td>
                                    <td>{{ l.amount }}</td>
                                    <td>{{ l.paid_till_now }}</td>
                                    <td>{{ l.remaining }}</td>
                                    <td>{{ l.total_percentage_paid }}</td>
                                    <td>{{ l.total_percentage }}</td>
                                </tr>
                                <tr>
                                    <td colspan="2">Overall Total</td>
                                    <td>{{ all_total_amount }}</td>
                                    <td>{{ all_total_paid }}</td>
                                    <td>{{ all_total_remaining }}</td>
                                    <td>{{ all_percentage_paid }}</td>
                                    <td>{{ all_percentage_remaining }}</td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-row>
                </div>
            </v-col>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
        data() {
            return {
                loader: false,
                color: "",
                // extraBreadcrumbItems: [


                // ],
                // breadcrumbClass: "breadcrumb-style1",
                snackbar: false,
                search: "",
                snackbar_msg: null,
                fees_structure_data: null,
                current_academic_year: null,
                stream: null,
                div: [],
                std: null,
                header: null,
                academic_year_list: null,
                standard_list: null,
                dision_list: [],
                stream_list: null,
                header_list: null,
                show: false,
                learner_info: [],
                data_list: [],
                component_headers: [],
                all_total_amount: null,
                all_total_paid: null,
                all_total_remaining: null,
                all_percentage_remaining:null,
                all_percentage_paid:null,
                sub_header_data: [],
                sub_header: [],
                org_basic_data: [],
                show_logo: true,
                status_list: [
                    { name: "All", id: "3" },
                    { name: "Active", id: "0" },
                    { name: "Temporary Inactive", id: "1" },
                    { name: "Permanent Inactive", id: "2" },
                ],
                status: null,
                circle_graph_details:[],
                option: {
            color: ["#278962", "#eb4034"],
            tooltip: {
                trigger: "item",
            },
            legend: {
                orient: "vertical",
                left: "center",
            },
            series: [
                {
                    name: "Access From",
                    type: "pie",
                    radius: "60%",
                    data: [
                        
                    ],
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: "rgba(0, 0, 0, 0.5)",
                        },
                    },
                },
            ],
        },
            };
        },
        computed: {
            filteredItems() {
                return this.learner_info.filter(item => {
                    const search = (this.search || '').toLowerCase();

                    return (
                        String(item.name || '').toLowerCase().includes(search) ||
                        String(item.reg_no || '').toLowerCase().includes(search)
                    );
                });
            }
        },
        methods: {
            fnExcelReport(id, name) {
                var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
                tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
                tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
                tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
                tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
                tab_text = tab_text + "<table border='1px'>";
                var exportTable = $("#" + id).clone();
                exportTable.find("input").each(function (index, elem) {
                    $(elem).remove();
                });
                tab_text = tab_text + exportTable.html();
                tab_text = tab_text + "</table></body></html>";
                var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

                //Save the file
                // var blob = new Blob([tab_text], {
                //     type: "application/vnd.ms-excel;charset=utf-8",
                // });
                // window.saveAs(blob, fileName);
                const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const filename = name+'.xls';

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    // For IE
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {
                    // For modern browsers
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = filename;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
            },
            showLogo() {
                if (this.show_logo) {
                    this.show_logo = false;
                } else {
                    this.show_logo = true;
                }
            },
            printReport() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
            ExportToExcel() {
                var htmltable = document.getElementById("my-table-id");
                var html = htmltable.outerHTML;
                window.open("data:application/vnd.ms-excel," + encodeURIComponent(html));
            },
            clear() {
                this.learner_info = [];
                this.data_list = [];
            },
            clearselection() {
                (this.show = false), (this.learner_info = []);
                this.data_list = [];
                (this.standard_list = null), (this.std = null), (this.div = []), (this.dision_list = []);
            },
            getAllReport() {
                this.loader = true;
                this.search = "";
                this.learner_info = [];
                this.data_list = [];
                const data = {
                    ay: this.current_academic_year.id,
                    std: this.std,
                    stream: this.stream,
                    div: this.div,
                    header: this.header,
                    sub_header: this.sub_header,
                    status: this.status,
                };
                axios
                    .post("/InstallmentStructureDetails/getAllReport", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.loader = false;
                            this.learner_info = res.data.learner_info;
                            this.data_list = res.data.data_list;
                            this.component_headers = res.data.component_headers;
                            this.all_total_amount = res.data.all_total_amount;
                            this.all_total_paid = res.data.all_total_paid;
                            this.all_total_remaining = res.data.all_total_remaining;
                            this.all_percentage_remaining = res.data.all_percentage_remaining;
                            this.all_percentage_paid = res.data.all_percentage_paid;
                            this.circle_graph_details = res.data.circle_graph_data;
                            var graph_data = [];
                            for (var i = 0; i < this.circle_graph_details.length; i++) {
                                graph_data.push(this.circle_graph_details[i]);
                            }
                            this.option.series[0].data = graph_data;
                            this.org_basic_data = res.data.org_basic_data;
                        } else {
                            //error
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        this.loader = false;
                    });
            },
            getStandard() {
                const data = {
                    ay: this.current_academic_year.id,
                    std: this.std,
                    stream: this.stream,
                };
                axios
                    .post("/InstallmentStructureDetails/getStandard", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.dision_list = res.data.dision_list;
                        } else {
                            //error
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            getSubHeader() {
                const data = {
                    ay: this.current_academic_year.id,
                    header: this.header,
                };
                axios
                    .post("/InstallmentStructureDetails/getSubHeader", data)
                    .then((res) => {
                        this.sub_header_data = res.data.sub_header_data;
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                    });
            },
            getStreamData() {
                const data = {
                    ay: this.current_academic_year.id,
                    stream: this.stream,
                };
                axios
                    .post("/InstallmentStructureDetails/getStreamData", data)
                    .then((res) => {
                        if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", "No division for this stream / Stream mapping not done for selected stream!!!"); // show snackbar on error
                            this.show = false;
                            return;
                        }
                        if (res.data.flag == "YES") {
                            this.show = true;
                            this.dision_list = res.data.dision_list;
                            this.standard_list = res.data.standard_list;
                            
                            if(this.standard_list.length > 0){
                                this.standard_list = [{ id: null, standard: "All" }, ...(res.data.standard_list || [])];
                            }
                        } else {
                            //error
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                    });
            },
            onload() {
                axios
                    .post("/InstallmentStructureDetails/getAllData")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.academic_year_list = res.data.ay_data;
                            this.current_academic_year = res.data.cay;
                            this.stream_list = res.data.stream_list;
                            this.header_list = res.data.header_list;

                            // this.dision_list = [{ div_name: "All", id: null }];
                        } else {
                            //error
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.get_ay_std_ft_loader = false;
                    });
            },
        },
        mounted() {
            this.onload();
        },
    };
</script>
<style scoped>
    /* .scroll {
  overflow-x: scroll;
} */
    .text-color {
        font-weight: bold;
        color: red;
        font-size: small;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
        font-size: small;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }

    .dt-button {
        font-size: small;
        font-weight: bold;
    }
    .dt-button.buttons-print::before {
        content: "\F42A";
        margin-right: 8px;
        margin-top: 8px;
        font-size: small;
    }
    .dt-button.buttons-excel::before {
        content: "\F21B";
        margin-right: 8px;
        margin-top: 8px;
        font-size: small;
    }
    .dt-button.buttons-csv::before {
        content: "\FEC2";
        margin-right: 8px;
        margin-top: 8px;
        font-size: small;
    }
    button.dt-button:hover:not(.disabled),
    div.dt-button:hover:not(.disabled),
    a.dt-button:hover:not(.disabled) {
        border-color: #ff9800;
        color: #ff9800;
    }
    .dataTables_wrapper .dataTables_filter input[type="search"] {
        border-radius: 2px;
        border: 1px solid #cdcdcd;
        cursor: auto;
        white-space: nowrap !important;
    }
    .pagebreak{
        page-break-before: always !important;
    }
    @media print {
        header,
        footer,
        nav,
        date {
            display: none !important;
        }

        img {
            width: 100% !important;
        }

        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }

        .box {
            background-color: white !important;
            /* margin: 8px !important;
    padding: 8px; */
            border: none !important;
            /* overflow: hidden !important; */
        }

        @page {
            size: A4;
            margin-top: none !important;
            padding-top: none;
            /* size: 16in 17in; */
            size: 20in 17in;
        }
        .scroll {
            overflow-x: hidden;
        }
        v-simple-table {
            overflow-x: hidden !important;
        }
        .trust-logo {
            width: 30% !important;
            height: 70% !important;
        }
        .schl-logo {
            width: 30% !important;
            height: 70% !important;
        }
    }
    .trust-logo {
        width: 86%;
    }
    .schl-logo {
        width: 86%;
    }
</style>
